// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28CsW","content":"styles_content__3ew2L"};